<template>
    <div>
        <div
            class="form-container mr-auto ml-auto mt-3"
            v-if="field.helpDescription !== null">
            <v-alert type="info"
                     class="mt-5 mb-5 mr-auto ml-auto"
                     border="right"
                     :color="primaryColor"
                     colored-border>
                {{ field.helpDescription }}
            </v-alert>
        </div>

        <div v-if="$route.path.includes('answer') && provider.opening_periods.length === 0">
            <v-alert
                type="info"
                text
                class="mt-5 mb-5 form-container mr-auto ml-auto"
                border="right"
                colored-border
            >
                <p>Aucune période d'ouverture renseignée</p>
            </v-alert>
        </div>

        <v-alert
            type="warning"
            v-if="provider.opening_periods.length === 0 && !disabled"
            class="mt-5 form-container mr-auto ml-auto"
            border="right"
            colored-border
        >
            <p>
                Vous n'avez pas renseigné vos horaires d'ouverture. Il s'agit d'une information importante pour vos visiteurs.
            </p>
            <p>Nous vous suggérons de prendre quelques minutes pour bien renseigner vos horaires d'ouverture.</p>
        </v-alert>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "OpeningPeriodTopAlert",
    props: ['field'],
    computed: {
        ...mapState("web_form", ['provider', 'disabled'])
    }
}
</script>
